import {
  replaceSocialLink,
  fetchSocialLink,
} from "../../firebase/FirebaseFunctions";
import { useState } from "react";
import {
  interestForm,
  interestFormType,
  groupMeLink,
  groupMeLinkType,
} from "../../firebase/models";
import googleFormImg from "../../imgs/companyLogos/googleformlogo.png";
import groupMeImg from "../../imgs/companyLogos/groupmelogo.png";
import { useEffect } from "react";
export default function InterestFormAndGroupMeLinkEntry() {
  const [interestFormLink, setInterestFormLink] = useState("");
  const [groupMeLinkState, setGroupMeLinkState] = useState("");
  //   const [interestFormTest, setInterestFormTest] = useState("");

  const [interestFormTest, setInterestFormTest] = useState<interestFormType[]>(
    []
  );
  const [groupMeTest, setGroupMeTest] = useState<groupMeLinkType[]>([]);

  useEffect(() => {
    const loadData = async () => {
      const [interestLinks, groupMeLinks] = await Promise.all([
        fetchSocialLink<interestFormType>("googleForm"),
        fetchSocialLink<groupMeLinkType>("groupMe"),
      ]);

      setInterestFormTest(interestLinks);
      setGroupMeTest(groupMeLinks);
    };

    loadData();
  }, []);

  const handleInterestForm = async (e: React.FormEvent) => {
    e.preventDefault();
    const newInterestForm = new interestForm(interestFormLink);
    await replaceSocialLink("googleForm", [newInterestForm]);
    // setInterestFormTest(interestFormLink);
    setInterestFormLink("");
  };

  const handleGroupMeLink = async (e: React.FormEvent) => {
    e.preventDefault();
    const newGroupMeLink = new groupMeLink(groupMeLinkState);
    await replaceSocialLink("groupMe", [newGroupMeLink]);
    setGroupMeLinkState("");
  };

  return (
    <>
      <div className="faq">
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "40px",
          }}
        >
          {/* Interest Form Section */}
          <div style={{ flex: "1", minWidth: "300px", maxWidth: "500px" }}>
            <h3 style={{ display: "flex", alignItems: "center" }}>
              REPLACE INTEREST FORM LINK
              <a
                href={interestFormTest[0]?.link ?? "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={googleFormImg}
                  style={{ width: 40, marginLeft: 10 }}
                  alt="Google Form"
                />
              </a>
            </h3>
            <form onSubmit={handleInterestForm}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <input
                  type="text"
                  placeholder="Interest Form Link"
                  value={interestFormLink}
                  onChange={(e) => setInterestFormLink(e.target.value)}
                  required
                  style={{ padding: 10, margin: 10, width: "100%" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <button
                  type="submit"
                  style={{
                    padding: 15,
                    backgroundColor: "lightgray",
                    borderRadius: 100,
                    borderWidth: 0,
                  }}
                >
                  REPLACE NEW INTEREST FORM LINK
                </button>
              </div>
            </form>
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <a
                href={interestFormTest[0]?.link ?? "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <h5>
                  Current Interest Form Link (stored in DB and on website)
                </h5>
              </a>
            </div>
          </div>

          {/* GroupMe Section */}
          <div style={{ flex: "1", minWidth: "300px", maxWidth: "500px" }}>
            <h3 style={{ display: "flex", alignItems: "center" }}>
              REPLACE GROUP ME LINK
              <a
                href={groupMeTest[0]?.link ?? "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={groupMeImg}
                  style={{ width: 40, marginLeft: 20 }}
                  alt="GroupMe"
                />
              </a>
            </h3>
            <form onSubmit={handleGroupMeLink}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <input
                  type="text"
                  placeholder="Group Me Link"
                  value={groupMeLinkState}
                  onChange={(e) => setGroupMeLinkState(e.target.value)}
                  required
                  style={{ padding: 10, margin: 10, width: "100%" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <button
                  type="submit"
                  style={{
                    padding: 15,
                    backgroundColor: "lightgray",
                    borderRadius: 100,
                    borderWidth: 0,
                  }}
                >
                  REPLACE GROUP ME LINK
                </button>
              </div>
            </form>
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <a
                href={groupMeTest[0]?.link ?? "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <h5>Current Group Me Link (stored in DB and on website)</h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
